import { Fragment, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { fileUrl } from '../../../utils'
import FileSelect from './FileSelect'

export default function SelectFile(props) {
  console.log('SelectFile rendered: ', props)
  const { field, handleChange, hasChanged, fileInfo, setFileInfo } = props

  const [modal, setModal] = useState(false)
  const [selectedFile, setSelectedFile] = useState(fileInfo.serverFileName)

  function toggle() {
    setModal(!modal)
  }

  function selectFile() {
    toggle()
    handleChange(selectedFile, hasChanged, field.id)
    const newFileInfo = {
      serverFileName: selectedFile,
      serverUrl: fileUrl(selectedFile),
      localFileName: null,
      blobUrl: null,
    }
    console.log(newFileInfo)
    setFileInfo(newFileInfo)
  }

  function closeModal() {
    toggle()
  }

  function handleSelectChange(event) {
    console.log(event.target.value)
    setSelectedFile(event.target.value)
  }
  
  return (
    <Fragment>
      <Modal isOpen={modal} backdrop='static' style={{ minWidth: '800px' }} >
        <ModalHeader toggle={toggle}>Select a {field.name} File</ModalHeader>
        <ModalBody style={{ textAlign: 'center', display: 'inline-block', maxWidth: 'none' }}>
          <FileSelect 
            field={field}
            handleChange={handleSelectChange}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeModal} >Cancel</Button>
          <Button color="primary" onClick={selectFile}>Select</Button>
        </ModalFooter>
      </Modal>
      <Button color="primary" size="sm" style={{ display: 'inline-block' }} onClick={() => { toggle() }}>Select File</Button>
    </Fragment>
  )
}
